export default __webpack_public_path__ + "static/media/3Estudiantes_combinado.f654a617.png";